import React, {Component} from 'react';
import {connect} from 'react-redux';
import DisplayUserPhoto from "../../users/DisplayUserPhoto";
import {getSignActorForType} from "../../../services/sign-actors";
import Tooltip from "../../../../shared/ui/Tooltip";

class ReportTableRow extends Component {
  // ----------------------
  // Render
  // ----------------------

  get canView() {
    if (this.props.report.getIsCompleted()) {
      return true;
    }
    if (!this.props.report.getIsSubmitted()) {
      return false;
    }
    return (!this.props.report.getCanAcknowledge(this.props.userContext.scope)
      && !this.props.report.getCanApprove(this.props.userContext.scope)
      && !this.props.report.getCanApproveTwo(this.props.userContext.scope)
      && !this.props.report.getCanApproveThree(this.props.userContext.scope)
      && !this.props.report.getCanApproveFour(this.props.userContext.scope)
      && !this.props.report.getCanApproveFive(this.props.userContext.scope))
      || this.props.userContext.hasScope('ftoc')
  }

  get canEditOrDelete() {
    if (this.props.report.getIsSubmitted()) {
      return false;
    }

    return (this.props.report.status === 'draft' || this.props.report.status === 'scheduled' || this.props.report.status === 'cancelled')
      && this.props.userContext.hasScope(['ftoc', 'sup']);
  }

  onDeleteReport(report) {
    if (report.status === 'draft') {
      this.props.onDeleteDraftReport(report.guid);
    }
    else if (report.status === 'scheduled' || report.status === 'cancelled') {
      this.props.onDeleteScheduledReport(report.guid);
    }
  }

  nextSignActor(nextApproval) {
    let nextSignActorId = getSignActorForType(this.props.report, this.props.report.type, nextApproval)
    if(nextSignActorId) {
      let user = this.props.users.find(u => u.guid === nextSignActorId)
      if(user) {
        return user.getFullName();
      }
    }

    return 'No Approver selected';
  }

  remindApprover(report) {
    let approverSteps = [
      {actor: 'approverOne', signFlowStep: 'approve_one', report: this.props.report},
      {actor: 'approverTwo', signFlowStep: 'approve_two', report: this.props.report},
      {actor: 'approverThree', signFlowStep: 'approve_three', report: this.props.report},
      {actor: 'approverFour', signFlowStep: 'approve_four', report: this.props.report},
      {actor: 'approverFive', signFlowStep: 'approve_five', report: this.props.report},

    ]
    for(let i = 0; i < approverSteps.length; i ++) {
      if(report.isNextSignAvailable(approverSteps[i].signFlowStep)) {
        this.props.onNotifyApprover(approverSteps[i])
        break;
      }
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return !this.props.report.getIsSubmitted() ? (
      <tr>
        <td>{this.props.report.date}</td>
        <td>
          <DisplayUserPhoto
            user={this.props.report.acknowledger}
            displayOnHover={true}
          >
            {this.props.report.getFullNameFor('acknowledger')}
          </DisplayUserPhoto>
        </td>
        <td>
          {this.props.report.author ? this.props.report.getFullNameFor('author') : ''}
        </td>
        <td>
          {this.props.report.trainingPhaseHeader}
        </td>
        <td>{this.props.report.formName}</td>
        <td>
          {this.props.report.status === 'draft' &&
          <span className="badge badge-secondary">
              Draft
            </span>
          }
          {this.props.report.status === 'cancelled' &&
            <span className="badge badge-disabled">
              Cancelled
            </span>
          }
          {this.props.report.status === 'rejected' &&
          <span className="badge badge-danger">
              Rejected
            </span>
          }
          {this.props.report.status === 'scheduled' &&
          <span className="badge badge-primary">
              Scheduled
            </span>
          }
          {this.props.report.status === 'acknowledged' &&
          <span className="badge badge-secondary">
           Acknowledged
          </span>}
          {this.props.report.status === 'submitted' &&
          <span className="badge badge-success">
           Submitted
          </span>}

            {this.props.report.getIsDueToday() &&
            <span className="badge badge-info">Submit Today</span>
            }
            {this.props.report.getIsDueNow() &&
            <span className="badge badge-warning">Submit Now</span>
            }
            {this.props.report.getIsLate() &&
            <span className="badge badge-danger">Late Submit</span>
            }
        </td>
        <td className="td-actions">
          {this.canEditOrDelete && (
            <div style={{display: 'flex'}}>
              <Tooltip tip="Edit report">
                <button
                  className="button default small"
                  onClick={() => this.props.onEditReport(this.props.report.guid)}
                  >
                  <i className="fa fa-edit" />
                </button>
              </Tooltip>

              <Tooltip tip="Delete report">
                <button
                  className="button default small"
                  onClick={() => this.onDeleteReport(this.props.report)}
                  >
                  <i className="fa fa-trash" />
                </button>
              </Tooltip>
            </div>
          )}
        </td>
      </tr>
    ) : (
      <tr>
        <td>{this.props.report.date}</td>
        <td>
          <DisplayUserPhoto
            user={this.props.report.acknowledger}
            displayOnHover={true}
          >
            {this.props.report.getFullNameFor('acknowledger')}
          </DisplayUserPhoto>
        </td>
        <td>
          {this.props.report.author ? this.props.report.getFullNameFor('author') : ''}
        </td>
        <td>
          {this.props.report.trainingPhaseHeader}
        </td>
        <td>{this.props.report.formName}</td>
        <td>
          {this.props.report.getIsAckDueToday() &&
            <Tooltip tip={this.props.report.getFullNameFor('acknowledger')}>
              <span>Acknowledge Today</span>
            </Tooltip>
          }
          {this.props.report.getIsAckDueNow() &&
            <Tooltip tip={this.props.report.getFullNameFor('acknowledger')}>
              <span className="badge badge-warning">Acknowledge Now</span>
            </Tooltip>
          }
          {this.props.report.getIsLateAck() &&
            <Tooltip tip={this.props.report.getFullNameFor('acknowledger')}>
              <span className="badge badge-danger">Late Acknowledgement</span>
            </Tooltip>
          }
          {this.props.report.getIsApprovalDueNow() &&
            <Tooltip tip={this.nextSignActor('approverOne')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverOne', signFlowStep: 'approve_one', report: this.props.report})} className="badge badge-warning">Approve 1 Now <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsLateApproval() &&
            <Tooltip tip={this.nextSignActor('approverOne')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverOne', signFlowStep: 'approve_one', report: this.props.report})} className="badge badge-danger">Late Approval 1 <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveTwoDueNow() &&
            <Tooltip tip={this.nextSignActor('approverTwo')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverTwo', signFlowStep: 'approve_two', report: this.props.report})} className="badge badge-warning">Approve 2 Now <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveTwoIsLate() &&
            <Tooltip tip={this.nextSignActor('approverTwo')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverTwo', signFlowStep: 'approve_two', report: this.props.report})} className="badge badge-danger">Late Approval 2 <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveThreeDueNow() &&
            <Tooltip tip={this.nextSignActor('approverThree')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverThree', signFlowStep: 'approve_three', report: this.props.report})} className="badge badge-warning">Approve 3 Now <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveThreeIsLate() &&
            <Tooltip tip={this.nextSignActor('approverThree')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverThree', signFlowStep: 'approve_three', report: this.props.report})} className="badge badge-danger">Late Approval 3 <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveFourDueNow() &&
            <Tooltip tip={this.nextSignActor('approverFour')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverFour', signFlowStep: 'approve_four', report: this.props.report})} className="badge badge-warning">Approve 4 Now <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveFiveDueNow() &&
            <Tooltip tip={this.nextSignActor('approverFive')}>
             <span onClick={() => this.props.onChangeApprover({actor: 'approverFive', signFlowStep: 'approve_five', report: this.props.report})} className="badge badge-warning">Approve 5 Now <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveFourIsLate() &&
            <Tooltip tip={this.nextSignActor('approverFour')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverFour', signFlowStep: 'approve_four', report: this.props.report})} data-tip={this.nextSignActor('approverFour')} className="badge badge-danger">Late Approval 4 <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsApproveFiveIsLate() &&
            <Tooltip tip={this.nextSignActor('approverFive')}>
              <span onClick={() => this.props.onChangeApprover({actor: 'approverFive', signFlowStep: 'approve_five', report: this.props.report})} data-tip={this.nextSignActor('approverFive')} className="badge badge-danger">Late Approval 5 <i className="fa fa-edit"></i></span>
            </Tooltip>
          }
          {this.props.report.getIsCompleted() &&
          <span className="badge badge-success">Complete</span>
          }
        </td>
        <td className="td-actions">
          {this.canView && (
            <Tooltip tip={"View report"}>
              <button
                className="button default small"
                data-tip="View report"
                onClick={() => this.props.onViewReport(this.props.report.guid)}
              >
                <i className="fa fa-list" />
              </button>
            </Tooltip>
          )}

          {!this.props.report.getIsAckDueToday() && !this.props.report.getIsAckDueNow() && !this.props.report.getIsLateAck() && (
            <Tooltip tip={"Send reminder"}>
              <button
                className="button default small"
                data-tip="Send reminder"
                onClick={() => this.remindApprover(this.props.report)}
              >
                <i className="fa fa-bell" />
              </button>
            </Tooltip>
          )}
        </td>
      </tr>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportTableRow);
